/** Shown only when a failed node carries no message at all — a row written
 *  before the control plane owned this copy. Everything else the editor
 *  renders comes from the backend verbatim. */
export const GENERIC_NODE_FAILURE = 'This step failed. Try running the process again.';

export const UNNAMED_NODE_LABEL = 'Unnamed step';
